import { render, staticRenderFns } from "./Card_commitment.vue?vue&type=template&id=521ba72a&scoped=true&"
import script from "./Card_commitment.vue?vue&type=script&lang=js&"
export * from "./Card_commitment.vue?vue&type=script&lang=js&"
import style0 from "./Card_commitment.vue?vue&type=style&index=0&id=521ba72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ba72a",
  null
  
)

export default component.exports